import { TitleType } from "@tm/models"
import { ReactText } from "react"
import { z } from "zod"

export const getAswegasMainSchema = (translateText: (key: ReactText) => string) =>
    z.object({
        processName: z.string({ required_error: translateText(37) }).min(1, translateText(37)),

        repairCoverage: z
            .string({ required_error: translateText(37) })
            .min(1, translateText(37))
            .refine((val) => ["0", "1"].includes(val), {
                message: translateText(37),
            }),
    })

export const getAswegasVehicleSchema = (t: (key: ReactText) => string) =>
    z.object({
        mileage: z.number({ required_error: t(37) }),
        registrationNo: z.string().trim().min(1, t(37)),
        initialRegistration: z.date({ required_error: t(289).replace("#1#", "8") }),
        plateNumber: z.string().trim().min(1, t(37)),
        vin: z.string().refine(
            (val) => val.length >= 17,
            (val) => ({
                message: val.length < 17 ? t(289).replace("#1#", "17") : t(1881),
            })
        ),
    })

export const getAswegasCustomerSchema = (t: (key: ReactText) => string, titleType?: TitleType) =>
    z.object({
        titleType: z.nativeEnum(TitleType, { required_error: t(37) }),
        firstName: titleType === TitleType.Company ? z.string().optional() : z.string().trim().min(1, t(37)),
        lastName: titleType === TitleType.Company ? z.string().optional() : z.string().trim().min(1, t(37)),
        companyName: titleType === TitleType.Company ? z.string().trim().min(1, t(37)) : z.string().optional(),
        street: z.string().trim().min(1, t(37)),
        zip: z.string().trim().min(1, t(37)),
        city: z.string().trim().min(1, t(37)),
        country: z.string().trim().min(1, t(37)),
    })
